<div class="table-responsive gung-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate>ID</th>
        <th translate>NAME</th>
        <th *ngIf="!isJosam" translate>Q_POPNR</th>
        <th *ngIf="isJosam" translate>JOSAM_STATNR</th>
        <th translate *ngIf="includeAvailability">AVAILABILITY</th>
        <th translate>PRICE</th>
        <th translate>RECOMMENDED_QTY_HEADER</th>
        <th style="min-width: 200px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mappedData">
        <td [attr.data-label]="'ID' | translate" *ngIf="item.replacementId == null">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.id }}
          </a>
        </td>
        <td [attr.data-label]="'ID' | translate" *ngIf="item.replacementId != null">
          <span [ngbPopover]="popContent2" triggers="mouseenter" [autoClose]="'outside'">
            <a (click)="goToDetail(item)" class="text-red">
              {{ item.id }} <i class="fas fa-exclamation-triangle"></i>
            </a>
          </span>
          <ng-template #popContent2>
            <div class="row">
              <div class="col text-center">
                <span translate>PRODUCT_REPLACED_BY</span> <br />
                <a (click)="goToDetail(item)" class="text-dark">
                  {{ item.replacementId }}
                </a>
              </div>
            </div>
          </ng-template>
        </td>
        <td [attr.data-label]="'NAME' | translate">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.name }}
          </a>
        </td>
        <td *ngIf="!isJosam" [attr.data-label]="'Q_POPNR' | translate">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.product?.extra?.ar.q_popnr }}
          </a>
        </td>
        <td *ngIf="isJosam" [attr.data-label]="'JOSAM_STATNR' | translate">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.product?.extra?.ar?.artnrean }}
          </a>
        </td>
        <td [attr.data-label]="'AVAILABILITY' | translate" *ngIf="includeAvailability">
          <lib-availability [availability]="item.availability" [isSales]="isSales"></lib-availability>
        </td>
        <td [attr.data-label]="'PRICE' | translate">
          @if (item.product.extra.ar?.itemstatuscode !== 98 && item.price?.extra?.contactSalesRep) {
          <span class="font-weight-bold" translate>CONTACT_YOUR_SALES_REPRESENTATIVE</span>
          } @else if (item.product.extra.ar?.itemstatuscode !== 98) {
          <div class="price-cell d-flex align-items-center">
            <div class="price-block">
              @if (item.price.backendPrice?.levels?.[0]?.extra?.campaign?.ordinaryPrl?.vb_pris) {
                <div>
                  <span class="original-price" [class.blur]="hidePrice">
                    {{ item.price.backendPrice.levels[0].extra.campaign.ordinaryPrl.vb_pris | number: '1.2-2' }} {{ item.price.customerGrossPrice.currencyCode }}
                  </span>
                </div>
              }
          <!--  <span *ngIf="item.price">
            <span class="font-weight-bold">
              {{ item.price.customerNetPrice.value | gungCurrency: item.price.customerNetPrice.currencyCode:'code' }}
            </span>
            <span *ngIf="item.price.customerDiscountPercent !== 0"
              >({{ item.price.customerGrossPrice.value | number: '1.0-0' }}&nbsp;-{{
                item.price.customerDiscountPercent
              }}%)</span
            >
            @if (item.price.customerDiscountPercent === 0 && item.price.backendPrice?.levels?.[0]?.extra?.prl?.nettoejrabkod == '1') {
              <span class="ml-2" translate>PRODUCT_WITHOUT_DISCOUNT</span>
            }
          </span> -->
          <div>
            <span *ngIf="item.price.customerDiscountPercent !== 0 || shouldDisplayGrossPrice; else noDiscount">
              <car-liner-price [price]="item.price" [display]="'code'" type="GROSS"
                [currency]="item.price.customerGrossPrice.currencyCode"
                class="font-weight-bold"></car-liner-price>&nbsp;
              <span [class.blur]="hidePrice">
                (-{{item.price.customerDiscountPercent}}% = {{ item.price.customerNetPrice.value | number: '1.2-2' }})
              </span>
            </span>
            <ng-template #noDiscount>
              <car-liner-price [price]="item.price" [display]="'code'" type="NET"
                [currency]="item.price.customerNetPrice.currencyCode" class="font-weight-bold"></car-liner-price>
              @if (item.price.backendPrice?.levels?.[0]?.extra?.prl?.nettoejrabkod == '1') {
              <span class="ml-2" translate>PRODUCT_WITHOUT_DISCOUNT</span>
              }
            </ng-template>
          </div>
              @if (item.price?.extra?.newPrice; as newPrice) {
                <div class="new-price" [class.blur]="hidePrice">
                  {{ 'NEW_PRICE_FROM' | translate }} {{ newPrice.date }} - {{ newPrice.value | number: '1.2-2' }} {{ newPrice.currencyCode }}
                </div>
              }
            </div>
            @if (item.price.backendPrice?.levels?.[0]?.extra?.campaign) {
              <div class="flex-grow-1 text-center">
                <span class="campaign-badge">
                  <span translate>CAMPAIGN_UNTIL</span><br class="campaign-date-break" />
                  {{ item.price.backendPrice.levels[0].extra.campaign.kampanjtomdat | date:'yyyy-MM-dd' }}
                </span>
              </div>
            }
          </div>
          }
        </td>
        <td [attr.data-label]="'RECOMMENDED_QTY_HEADER' | translate">
          @if(item.product?.extra?._addonPcs){
          <div class="text-truncate">
            <span translate>RECOMMENDED_QTY</span> {{item.product?.extra?._addonPcs}} {{
            item.product?.extra?.ar?.enhetskod || '' }}
          </div>
          }
        </td>
        <td [attr.data-label]="'BUY' | translate" style="width: 200px">
          @if (item.product.extra.ar?.itemstatuscode !== 98) {
          <lib-buy-btn [id]="item.id" [product]="item.product"> </lib-buy-btn>
          }
        </td>
        <td *ngIf="item.product.extra?.sr">
          <i class="fad fa-sort-size-down" (click)="openIncludedItemsModal(item.product)"></i>
        </td>
        <!-- <div class="included-items-icon-wrapper" *ngIf="data.product.extra?.sr" >
            <i class="fad fa-sort-size-down" (click)="openIncludedItemsModal(data.product);"></i>
          </div> -->
      </tr>
    </tbody>
  </table>
  <div *ngIf="findError" class="mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>